module.exports = __webpack_public_path__ + "img/video-call-black.4ed04b9c.svg";